module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-group">\n    <label class="DescartesUILabel">' +
((__t = (labelUrlText)) == null ? '' : __t) +
'</label>\n    <input name="url" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (url)) == null ? '' : __t) +
'">\n</div>\n<div class="form-group">\n    <label class="DescartesUILabel">' +
((__t = (labelVersionText)) == null ? '' : __t) +
'</label>\n    <input name="version" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (version)) == null ? '' : __t) +
'">\n</div>\n</br>\n<div class="form-check">\n     <input class="form-check-input" type="checkbox" value="" id="DescartesNoUseUrlCapabilitiesCheckBox" />\n     <label class="form-check-label" for="DescartesNoUseUrlCapabilitiesCheckBox">' +
((__t = (labelNoUseUrlCapabilitiesText)) == null ? '' : __t) +
'</label>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/ChooseWmsLayers.ejs
// module id = 408
// module chunks = 0